import React from 'react';

import PropTypes from 'prop-types';

import { SidebarInset as ShadcnSidebarInset } from '@/components/ui/sidebar';

const SidebarInset = ({ children }) => (
  <ShadcnSidebarInset className="flex h-[calc(100vh-1rem)] flex-col gap-5 overflow-y-auto">
    {children}
  </ShadcnSidebarInset>
);

SidebarInset.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SidebarInset;
